import EmptySilhouette from '@/assets/images/bg-img-2.png';
import HeroLogoEn from '@/assets/images/hero-logo-en.png';
import HeroLogoAr from '@/assets/images/hero-logo-ar.png';
import Avatars from '@/assets/images/floating-avatars.png';
import Logo from '@/assets/images/family-mode-logo.png';
import LabelName from '@/assets/images/label-name.png';
import EmptyTape from '@/assets/images/bg-img-1.png';
import PopupBg from '@/assets/images/popup-bg.png';
import Avatar from '@/assets/images/avatar.png';

export const Images = {
  Logo,
  EmptyTape,
  EmptySilhouette,
  LabelName,
  PopupBg,
  Avatar,
  HeroLogoEn,
  HeroLogoAr,
  Avatars
};
